(() => {
  if (customElements.get('apex-cart-delivery')) return;
  const MAX_AGE = 15 * 60 * 1000;
  const EU = new Set('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' '));
  class CartDeliveryMessage extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh || this.update.bind(this);
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.refresh);
      queueMicrotask(this.refresh);
    }
    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
    }
    update() {
      clearTimeout(this.expiryTimer);
      const fallback = this.querySelector('[data-delivery-fallback]');
      const free = this.querySelector('[data-delivery-free]');
      if (!fallback || !free) return;
      fallback.hidden = false;
      free.hidden = true;
      if (!this.isConnected || !EU.has(this.dataset.country)) return;
      let lines;
      try { lines = JSON.parse(this.dataset.lines); } catch { return; }
      const now = Date.now();
      if (!Array.isArray(lines) || !lines.length || lines.length !== Number(this.dataset.lineCount)) return;
      let expiresAt = Infinity;
      for (const line of lines) {
        if (!line || line.version !== 1 || !Array.isArray(line.countries) ||
            !line.countries.includes(this.dataset.country) ||
            !Number.isSafeInteger(line.observedAt) || !Number.isSafeInteger(line.expiresAt) ||
            line.observedAt > now || line.expiresAt <= now || line.expiresAt <= line.observedAt ||
            line.expiresAt - line.observedAt > MAX_AGE) return;
        expiresAt = Math.min(expiresAt, line.expiresAt);
      }
      fallback.hidden = true;
      free.hidden = false;
      this.expiryTimer = setTimeout(this.refresh, expiresAt - now);
    }
  }
  customElements.define('apex-cart-delivery', CartDeliveryMessage);
})();
